module.exports = __webpack_public_path__ + "img/184.5db50073.jpg";